<template>
    <div class="form-group">
        <label class="headings">{{label}}</label>
        <div class="radio-style-xx" v-for="(itm,idx) in values" :key="id + '-' + idx">
            <input v-if="itm.id == lastItem.id" :id="itm.id" :name="itm.name" type="radio" v-model="selected" :value="itm.value" v-taurus-validator="'required'" :fieldlabel="validationFieldLabel">
            <input v-else :id="itm.id" :name="itm.name" type="radio" v-model="selected" :value="itm.value">
            <label :for="itm.id">{{itm.label}}</label>
        </div>
        <div :name="lastItem.id" :invalidfeedback="validationInvalidFeedback"></div>
    </div>
</template>
<script>
export default {
    props: {
        value: { required: true },
        id: { required: true },
        label: { required: true },
        values: { required: true },
        validationFieldLabel: {required:true},
        validationInvalidFeedback: {required:true}
    },
    components: {
        
    },
    data: () => {
        return {
            selected: null
        }
    },
    mounted() {
        this.selected = this.value
    },
    computed: {
        lastItem() {
            if (this.values && Array.isArray(this.values)) {
                return this.values[this.values.length -1];
            }
        }
    },
    watch:{
        value(newVal,oldVal) {
            if (newVal != this.selected) {
                this.selected = this.value
            }
        },
        selected(newVal) {
            this.$emit('input', this.selected);
        }
    }
}
</script>